export default "__VITE_ASSET__Bqu7AEwV__"